import { cn } from "@/lib/utils";
import { Card } from "@/components/ui/card";
import { type Tone, toneText, toneDot } from "./labels";

// A big number with a plain-English caption. Tone rides on a small dot + the number's
// colour, never colour alone. Calm: one focal number per tile.
export function KpiTile({
  value,
  caption,
  secondary,
  tone = "neutral",
  className,
}: {
  value: React.ReactNode;
  caption: string;
  secondary?: string;
  tone?: Tone;
  className?: string;
}) {
  return (
    <Card className={cn("p-4 flex flex-col gap-1 min-w-[9rem]", className)}>
      <div className="flex items-center gap-2">
        {tone !== "neutral" && <span className={cn("h-1.5 w-1.5 rounded-full shrink-0", toneDot(tone))} aria-hidden />}
        <span className={cn("font-heading text-3xl font-semibold leading-none", toneText(tone))}>{value}</span>
      </div>
      <span className="font-body text-xs text-muted-foreground leading-snug">{caption}</span>
      {secondary && <span className="font-body text-[11px] text-muted-foreground/80 leading-snug">{secondary}</span>}
    </Card>
  );
}
